import { UtilsBrowser } from "../utils/UtilsBrowser";
import { routeShouldRenderComponent } from "../utils/UtilsLayout";
import {
  ROUTES_NO_COOKIE_NOTICE,
  ROUTES_NO_HEADER,
  ROUTES_NO_FOOTER,
  ROUTES_NO_HELP_TIPS,
} from "../configs/layout";
import { ROUTES } from "../configs/routes";

export const useRouteChecks = (pathname: string) => {
  const shouldShowCookieNotice =
    !UtilsBrowser.isInternetExplorer() &&
    !routeShouldRenderComponent(pathname, ROUTES_NO_COOKIE_NOTICE);

  const shouldShowHeader =
    !UtilsBrowser.isInternetExplorer() &&
    !routeShouldRenderComponent(pathname, ROUTES_NO_HEADER);

  const shouldShowFooter =
    !UtilsBrowser.isInternetExplorer() &&
    !routeShouldRenderComponent(pathname, ROUTES_NO_FOOTER);

  const shouldShowHelpTips =
    !UtilsBrowser.isInternetExplorer() &&
    !routeShouldRenderComponent(pathname, ROUTES_NO_HELP_TIPS);

  const isMaintenancePage = pathname === ROUTES.ERROR_MAINTENANCE;

  return {
    shouldShowCookieNotice,
    shouldShowHeader,
    shouldShowFooter,
    shouldShowHelpTips,
    isMaintenancePage,
  };
};
